import { render, staticRenderFns } from "./AddClawbackModal.vue?vue&type=template&id=bd955a74&scoped=true"
import script from "./AddClawbackModal.vue?vue&type=script&lang=js"
export * from "./AddClawbackModal.vue?vue&type=script&lang=js"
import style0 from "./AddClawbackModal.vue?vue&type=style&index=0&id=bd955a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd955a74",
  null
  
)

export default component.exports